import { render, staticRenderFns } from "./ConfirmForgotPassword.vue?vue&type=template&id=f771416e&scoped=true"
import script from "./ConfirmForgotPassword.vue?vue&type=script&lang=js"
export * from "./ConfirmForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./ConfirmForgotPassword.vue?vue&type=style&index=0&id=f771416e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f771416e",
  null
  
)

export default component.exports